<template>
  <div>
    <div class="section">
      <el-button
        v-show="btnshowAWindow"
        type="primary"
        @click="showAWindowClickHandler"
      >{{ $t('SeaExport.ViewAssociatedBusiness') }}</el-button>
    </div>
    <div class="section">
      <span class="title">{{ $t('SeaExport.DangerousGoods') }}</span>
      <div style="display:flex;flex-direction:row">
        <el-form
          label-width="190px"
          label-position="left"
          style="display:flex;flex-direction:column"
        >
          <el-form-item label-width="0" class="auto-width">
            <cargo-ag-grid
              :grid-options="danger.gridOptions"
              :column-defs="dangerColumnDefs"
              :row-data="specialGoods"
              style="width: 515px;height: 200px"
              @gridReady="params=>{danger.gridApi=params.api}"
            />
            <div style="width:100%">
              <div style="float:right;padding:5px">
                <el-button
                  type="primary"
                  :disabled="!isEditing"
                  @click="addSpGoods()"
                >{{ $t('SpecialGoods.Add') }}</el-button>
                <el-button
                  type="danger"
                  style="margin-left: 5px;"
                  :disabled="!isEditing"
                  @click="delSpGoods()"
                >{{ $t('SpecialGoods.Delete') }}</el-button>
                <el-upload
                  :disabled="!isEditing"
                  action="string"
                  :http-request="importSpGoods"
                  :show-file-list="false"
                  accept=".jpg, .jpeg, .png"
                  :before-upload="beforeUploadSpgGoods"
                  style="display: inline-block;padding-left: 5px;"
                >
                  <el-button
                    :disabled="!isEditing"
                    type="primary"
                  >{{ $t('SpecialGoods.Import') }}</el-button>
                </el-upload>
                <el-button
                  style="margin-left: 5px;"
                  type="primary"
                  :disabled="!isEditing"
                  @click="fillInSpGoods()"
                >{{ $t('SpecialGoods.FillIn') }}</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.CLASSNO')">
            <el-input v-model="editObj.danClassNo" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.SecondarySpecialGoods')">
            <el-input v-model="editObj.secondarySpecialGoods" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.UNNO')">
            <el-select
              ref="danUNNo"
              v-model="editObj.danUNNo"
              :disabled="!isEditing"
              :placeholder="!isEditing ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
              filterable
              clearable
              :allow-create="true"
              @blur="txtdDnUNNoFocusOutHandler()"
            >
              <el-option
                v-for="(item,index) in dangerousGoods"
                :key="index"
                :label="item.code"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.PACKING')">
            <el-input v-model="editObj.danPacking" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DangerousGoodsLabel')">
            <el-input v-model="editObj.danLable" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.EMS')">
            <el-input v-model="editObj.danEMS" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.Point')">
            <el-input v-model="editObj.danPoint" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.Isolation')" class="bold">
            <el-input v-model="editObj.danIsolation" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.MedicalEmergencyGuideNo')">
            <el-input v-model="editObj.danMfagNo" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.man24')">
            <el-input v-model="editObj.dan24man" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.tel24')">
            <el-input v-model="editObj.dan24tel" :disabled="!isEditing" />
          </el-form-item>
        </el-form>
        <el-form
          label-width="120px"
          label-position="left"
          style="display:flex;flex-direction:column;margin-left:20px"
          :disabled="!isEditing"
        >
          <el-form-item :label="$t('SpecialGoods.ResponsibleParty')">
            <el-input v-model="editObj.responsibleParty" style="width:215px;" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.HSCODE')">
            <el-input v-model="editObj.hsCode" style="width:215px;" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.PickTime')">
            <el-input v-model="editObj.danPickTime" style="width:215px;" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.SeaPullution')">
            <el-input
              v-model="editObj.danSeaPullution"
              :placeholder="!isEditing ? '' : $t('SpecialGoods.OnlyEnterYN')"
              style="width:215px;"
              @change="limitInput"
            />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.CorrectTransportName')">
            <el-input v-model="editObj.correctTransportName" style="width:215px;" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.GrossWeight')">
            <el-input-number
              v-model="editObj.grossWeight"
              :min="0"
              :max="999999999999"
              :precision="3"
              controls-position="right"
              style="width:215px;"
            />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.NeatWeight')">
            <el-input-number
              v-model="editObj.neatWeight"
              :min="0"
              :max="999999999999"
              :precision="3"
              controls-position="right"
              style="width:215px;"
            />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.OuterPackagingType')">
            <el-input v-model="editObj.outerPackagingType" style="width:215px;" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.OuterPackagingQuantity')">
            <el-input-number
              v-model="editObj.outerPackagingQuantity"
              :min="0"
              :max="999999999999"
              controls-position="right"
              style="width:215px;"
            />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.InnerPackagingType')">
            <el-input
              v-model="editObj.innerPackagingType"
              :placeholder="!isEditing ? '' : $t('SpecialGoods.ThisFieldRequired')"
              style="width:215px;"
            />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.InnerPackagingQuantity')">
            <el-input-number
              v-model="editObj.innerPackagingQuantity"
              :min="0"
              :max="999999999999"
              :precision="0"
              controls-position="right"
              style="width:215px;"
            />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.Remark')">
            <el-input v-model="editObj.remark" type="textarea" :rows="2" style="width:215px;" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.PackingCode')">
            <el-input v-model="editObj.packingCode" style="width:215px;" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 危险品-关联业务 -->
    <special-goods-dialog
      :visible.sync="specialGoodsDialog.visible"
      :a-data="specialGoodsDialog.aData"
      :o-job="specialGoodsDialog.oJob"
      :job="specialGoodsDialog.job"
      @refreshCache="refreshCache"
    />
    <imdg-code-select-dialog
      :visible.sync="imdgCodeSelDialog.visible"
      :imdg-codes="imdgCodeSelDialog.imdgCodes"
      @onImdgCodeSelSucceed="onImdgCodeSelSucceed"
    />
  </div>
</template>

<script>
import SpecialGoodsDialog from '@/components/Cargo/Job/specialGoodsDialog'
import ImdgCodeSelectDialog from '@/components/Cargo/Job/imdgCodeSelectDialog'
import { TabError } from '@/utils/class/TabError'
import { sortByMultiField } from '@/utils'
import StrUtils from '@/utils/StrUtils'
import * as EQSize from '@/class/cargo/model/parameters/EQSize'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SpecialGoods } from '@/class/model/booking/SpecialGoods'
import { querySpecialAssociatedBusiness } from '@/api/seaExport/containerUsage'
import { importSpecialGoods, getContainerUsages } from '@/api/seaExport/specialGoods'
import { getDangerousGoodsList } from '@/api/basicData/dangerousGoods'
import { getIMDGCodeByUNNo } from '@/api/sysManage/imdgCode'

export default {
  name: 'RBTabSpecialGoods',
  components: { ImdgCodeSelectDialog, SpecialGoodsDialog },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true }
  },
  data() {
    return {
      isEditing: false,
      currentState: '',
      btnshowAWindow: false,
      job: { cargoType: '' },
      danger: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowClicked: this.goodsItemClickHandler
        },
        rowData: [],
        gridApi: null
      },
      specialGoods: [],
      colSoNo: [], // soNoList
      delSpecialGoodsUuids: [],
      editObj: new SpecialGoods().fillDefaultValue().getData(),
      dangerousGoods: [],
      containerUsages: [],
      specialGoodsDialog: {
        visible: false,
        aData: {}
      },
      imdgCodeSelDialog: {
        visible: false
      }
    }
  },
  computed: {
    readonly() {
      return this.action === 'look'
    },
    isEdit() {
      return this.action !== 'look'
    },
    dangerColumnDefs() {
      const columnDefs = [
        {
          headerName: '',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.SpecialCargoNumber'),
          field: 'danNo',
          width: 133
        },
        {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          field: 'englishCommodity',
          width: 109,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'cargo-cell-input'
          }
        },
        {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'chineseCommodity',
          width: 109,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'cargo-cell-input'
          }
        },
        {
          headerName: 'SONO.',
          field: 'soNo',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'cargo-cell-select',
            optionField: {
              label: 'sonos',
              value: 'sonos',
              filterable: false
            },
            attrs: {
              cellSelectAttrs: { fullOptions: [... this.colSoNo] }
            }
          }
        }
      ]
      return columnDefs
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      this.job = row
      this.delSpecialGooodsUuids = []
      // 判断是否分公司委托货或跨tenant委托
      const consignationByCompany = StrUtils.isEmpty(this.job.relatedJob) && this.isEdit
      const consignationByTenant = !StrUtils.isEmpty(this.job.relatedJob) && this.isEdit
      this.isEditing = consignationByCompany || consignationByTenant
      if (!isRefresh) {
        this.loadColSoNo()
        return
      }
      this.btnshowAWindow = (StrUtils.isEmpty(this.job.relatedJob) && !StrUtils.isEmpty(this.job.trustFromJob)) ||
        (StrUtils.isEmpty(this.job.trustFromJob) && !StrUtils.isEmpty(this.job.relatedJob))
      this.dataChanged()
      this.goodsItemClickHandler({ data: this.editObj })
      this.initDangerousGoods()
    },
    async txtdDnUNNoFocusOutHandler() {
      const editObj = this.editObj
      const elSelect = this.$refs.danUNNo
      const innerInput = elSelect.$children[0].$refs.input
      editObj.danUNNo = innerInput.value
    },
    // 联合国编号下拉框
    initDangerousGoods() {
      this.dangerousGoods = []
      getDangerousGoodsList('').then(res => {
        console.info('res.data.list：' + res.data.list)
        this.dangerousGoods = res.data.list
      })
    },
    getSubmitData() {
      let specialGoods = []
      if (this.job.cargoType === 'DG') {
        this.validateForm()
        specialGoods = this.specialGoods
      } else {
        specialGoods.push(this.editObj)
      }
      return {
        specialGoods,
        delSpecialGoodsUuids: this.delSpecialGoodsUuids
      }
    },
    validateForm() {
      // 如果外包装类型是4G，则内包装类型栏和内包装件数栏位必须要求填写
      for (const spg of this.specialGoods) {
        if (!StrUtils.isEmpty(spg.outerPackagingType)) {
          const outPacking = spg.outerPackagingType
          if (outPacking === '4G') {
            if (StrUtils.isEmpty(spg.innerPackagingType)) {
              throw new TabError(this.$t('Message.InnerPackagingTypeIsRequired'), 'tabSpecialGoods')
            }
            if (!spg.innerPackagingQuantity) {
              throw new TabError(this.$t('Message.InnerPackagingQuantityIsRequired'), 'tabSpecialGoods')
            }
          }
        }
        if (!StrUtils.isEmpty(spg.danSeaPullution)) {
          const seaPollution = spg.danSeaPullution
          const isPollutionCheckFailed = !StrUtils.isEmpty(seaPollution) && seaPollution !== 'Y' && seaPollution !== 'N'
          if (isPollutionCheckFailed) {
            throw new TabError(this.$t('Message.SeaPollutionOnlyEnterYN'), 'tabSpecialGoods')
          }
        }
      }
      return true
    },
    // 查看关联业务
    showAWindowClickHandler() {
      const params =
      {
        trustFromJobNo: this.job.trustFromJob,
        relatedJobNo: this.job.relatedJob
      }
      //  调用api
      querySpecialAssociatedBusiness(params).then(res => {
        this.queryWindowResultHandler(res.data)
      })
    },
    queryWindowResultHandler(data) {
      const nJob = data.resultSea // SeaExportJob
      nJob.specialGoods = data.specialGoods
      if (nJob.cargoType === 'DG') {
        this.specialGoodsDialog.aData = data
        this.specialGoodsDialog.job = nJob
        this.specialGoodsDialog.oJob = this.job
        this.specialGoodsDialog.currentStateType = this.currentState
        this.specialGoodsDialog.visible = true
      } else {
        this.$message.info(this.$t('SeaExport.RelatedBusinessNoSpecial'))
      }
    },
    async refreshCache() {
      const jobClass = new SeaExportJob(this.job)
      jobClass.specialGoods = ''
      await jobClass.getSpecialGoods()
      this.specialGoods = this.job.specialGoods

      this.loadSuccess()
    },
    limitInput(val) {
      if (val !== 'Y' && val !== 'N') {
        this.editObj.danSeaPullution = ''
      }
    },
    beforeUploadSpgGoods(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'png'
      const extension2 = fileType === 'jpeg'
      const extension3 = fileType === 'jpg'
      if (!extension && !extension2 && !extension3) {
        this.$message.error(this.$t('SeaExport.UploadImageFormatWrong'))
      }
      return extension || extension2
    },
    // 危险品-导入
    importSpGoods(item) {
      const jobParams = { ... this.job }
      for (const key in jobParams) {
        if (typeof jobParams[key] === 'object') {
          delete jobParams[key]
        }
      }

      const params = {
        file: item.file,
        job: JSON.stringify(jobParams)
      }
      importSpecialGoods(params).then(response => {
        if (response.data == null || response.data === '') {
          this.$message.warning(this.$t('SeaExport.FileContentWrong'))
        } else {
          this.importResultHandler(response.data)
        }
      })
    },
    // 组装打印参数
    getPrintData() {
      if (!this.editObj.uuid) {
        this.$message.warning(this.$t('SeaExport.ChooseSpecialGoods'))
        return
      }
      const params = {}
      if (this.job && this.editObj.uuid) {
        params.jobuuid = this.job.uuid
        params.JOB_UUID = this.job.uuid
        params.SPECIAL_GOOD_UUID = this.editObj.uuid
        params.category = 'SPECIAL_GOODS'
        params.ctx = new SeaExportJob(this.job)
        // TemplateSelectorWin.getInstance().showThisWin(job, "SPECIAL_GOODS", params, this);
      }
      this.$logger.log('params', params)
      return params
    },
    async dataChanged() {
      if (!this.job) return
      this.changeCurrentState()
      const jobClass = new SeaExportJob(this.job)
      await jobClass.getSpecialGoods()
      this.specialGoods = this.job.specialGoods
      this.loadSuccess()
    },
    loadSuccess() {
      this.loadColSoNo()

      if (this.specialGoods != null && this.specialGoods.length > 0) {
        if (this.job.cargoType === 'DG') {
          this.sortByOrder(this.specialGoods)
          // 目前没有危险品编号，需要生成
          if (this.editObj && StrUtils.isEmpty(this.editObj.danNo)) {
            this.editObj.danNo = JobUtils.createDanNo(this.job)
          }

          this.$nextTick(async() => {
            await this.setRowSelect(this.editObj)
            this.goodsItemClickHandler()
          })
        } else {
          this.editObj = this.specialGoods[0]
        }
      } else {
        if (this.currentState === 'DG') {
          // _editObj置空，清空表单
          this.editObj = new SpecialGoods().fillDefaultValue().getData()
          this.specialGoods = []
          this.containerUsages = []
        }
        // _editObj此时必是空，如果是除危险品之外，其他的特殊物品，则默认新建一个【h5这边 this.editObj 是一个对象不会为null】
        if (this.currentState !== 'DG' && (this.editObj === null || !this.editObj.jobUuid)) {
          this.editObj = new SpecialGoods().fillDefaultValue().getData()
          this.editObj.jobUuid = this.job.uuid
        }
      }
    },
    loadColSoNo() {
      this.colSoNo = []
      const soNoArray = this.job.soNo.split('\n')
      for (const str of soNoArray) {
        this.colSoNo.push({ 'sonos': str })
      }
    },
    /**
     * 按照指定字段排序
     * @param categoryArray
     * @return
     */
    sortByOrder(categoryArray) {
      if (categoryArray === null || categoryArray.length === 0) {
        return null
      } else {
        sortByMultiField(categoryArray, ['danNo'], false)
      }
    },
    // 设置 选中行(加载数据后默认选中第一行记录)
    setGridSelect(selectLastRow = false) {
      const nodes = this.danger.gridOptions.api.getRenderedNodes()

      // 选中最后一行记录(用于 行 新增，删除)
      if (selectLastRow) {
        let index = 0
        for (const item of nodes) {
          if (index === nodes.length - 1) {
            item.setSelected(true)
            this.editObj = item.data
          }
          index++
        }
      } else {
        // 默认选中第一个
        for (const item of nodes) {
          item.setSelected(true)
          this.editObj = item.data
          break
        }
      }
    },
    // 设置 选中行(加载数据后默认选中第一行记录)
    setRowSelect(data) {
      const nodes = this.danger.gridOptions.api.getModel().rowsToDisplay
      const item = nodes.find(node => node.data.danNo === data.danNo)
      item.setSelected(true)
    },
    goodsItemClickHandler(event = null) {
      if (event) {
        this.editObj = event.data
      }

      const selItem = this.editObj
      let editObj = this.editObj

      if (selItem !== editObj) {
        editObj = selItem
        if (editObj === null || !editObj.jobUuid) {
          // 危险品被全部删除，因HSCode不在_editObj中，要把页面的hscode清空掉
          editObj.hsCode = ''
        }
      }

      // 获取 ContainerUsages
      this.containerUsages = []
      if (editObj && !StrUtils.isEmpty(editObj.uuid)) {
        getContainerUsages({ specialGoodsUuid: editObj.uuid }).then(res => { this.loadUsageResultHandler(res.data) })
      }
    },
    loadUsageResultHandler(data) {
      if (this.editObj) {
        if (StrUtils.isEmpty(data)) {
          this.containerUsages = []
        } else {
          this.containerUsages = data
        }
      }
    },
    changeCurrentState() {
      if (this.job) {
        const cargoType = this.job.cargoType
        if (cargoType) {
          this.currentState = cargoType
        }
      }
    },
    // 危险品-新增
    addSpGoods() {
      const job = this.job
      if (StrUtils.isEmpty(this.job.uuid)) {
        this.$message.warning(this.$t('Message.FirstSaveTheBusinessAddSpecialGoods'))
        return
      }
      const specialGoods = new SpecialGoods().fillDefaultValue().getData()
      this.specialGoods.push(specialGoods)
      job.specialGoods = this.specialGoods
      specialGoods.jobUuid = job.uuid
      specialGoods.hsCode = job.hsCode
      specialGoods.danNo = JobUtils.createDanNo(job)
      this.editObj = specialGoods

      this.$nextTick(async() => {
        this.setGridSelect(true)
        this.goodsItemClickHandler()
      })
    },
    // 危险品-删除
    delSpGoods() {
      const selSpGoods = this.danger.gridApi.getSelectedRows()
      if (selSpGoods === null || selSpGoods.length === 0) {
        this.$message.info(this.$t('Message.PleaseSelectData'))
        return
      }

      for (const spg of selSpGoods) {
        // spg.containerUsages = null 后端保存移除 关联装箱信息
        const index = this.specialGoods.findIndex(p => p.danNo === spg.danNo)
        if (!StrUtils.isEmpty(spg.uuid)) {
          this.delSpecialGoodsUuids.push(spg.uuid)
        }
        this.specialGoods.splice(index, 1)
      }
      if (this.specialGoods && this.specialGoods.length > 0) {
        this.$nextTick(async() => {
          await this.setGridSelect()
        })
      } else {
        this.editObj = {}
      }

      this.goodsItemClickHandler()
    },
    // 危险品-导入-结果处理
    importResultHandler(result) {
      if (result) {
        const code = result.code
        const msg = result.msg
        if (code === '0') {
          const selItem = this.editObj
          selItem.secondarySpecialGoods = result.goods['secondarySpecialGoods']
          selItem.danUNNo = result.goods['danUNNo']
          selItem.grossWeight = result.goods['grossWeight']
          selItem.neatWeight = result.goods['neatWeight']
          selItem.outerPackagingType = result.goods['outerPackagingType']
          selItem.chineseCommodity = result.goods['chineseCommodity']
          selItem.englishCommodity = result.goods['englishCommodity']
        } else {
          this.$message.error(msg + this.$t('Message.Error'))
        }
      }
    },
    // 危险品-关联
    fillInSpGoods() {
      const selItem = this.danger.gridApi.getSelectedRows()
      if (selItem === null || selItem.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return
      }
      if (StrUtils.isEmpty(this.editObj.danUNNo)) {
        this.$message.warning(this.$t('Message.UNNoIsEmpty'))
        return
      }
      getIMDGCodeByUNNo({ unNo: this.editObj.danUNNo }).then(res => { this.getHsCodeHandler(res.data) })
    },
    getHsCodeHandler(data) {
      const imdgCodes = data
      // const selItem = this.danger.gridApi.getSelectedRows()
      // 如果只能查到一个imdgcode则直接填充，多个则通过窗口选择
      if (imdgCodes && imdgCodes.length > 0) {
        if (imdgCodes.length === 1) {
          const imdgCode = imdgCodes[0]
          this.fillInFromImdgCode(this.editObj, imdgCode)
        } else {
          this.imdgCodeSelDialog.imdgCodes = imdgCodes
          this.imdgCodeSelDialog.visible = true
        }
      } else {
        this.$message.warning(this.$t('Message.NoAssociatedInfo'))
      }
    },
    onImdgCodeSelSucceed(imdgCode) {
      if (imdgCode) {
        this.fillInFromImdgCode(this.editObj, imdgCode)
      }
    },
    /**
     * 将imdgCode里的一些值填充到specialGoods中
     */
    fillInFromImdgCode(specialGoods, imdgCode) {
      specialGoods.danClassNo = imdgCode.classification
      specialGoods.danPacking = imdgCode.packingGroup
      specialGoods.danEMS = imdgCode.emergencySchedule
      specialGoods.danPoint = imdgCode.flashpoint
      specialGoods.correctTransportName = imdgCode.psn

      let subsidiaryRisks = imdgCode.subsidiaryRisks
      const isEight = !StrUtils.isEmpty(subsidiaryRisks) && (subsidiaryRisks === '3+8' || subsidiaryRisks === '3(8)' || subsidiaryRisks === '3/8')
      if (isEight) {
        subsidiaryRisks = '8'
      }
      specialGoods.secondarySpecialGoods = subsidiaryRisks
    }
  }
}
</script>

<style scoped lang="scss">
#app .section .bold ::v-deep {
  .el-form-item__label {
    font-weight: bold;
    font-size: 14px;
  }
}
</style>
